import { Card, Typography, Box, Button, Divider } from '@mui/joy'
import { chatApiList } from 'components/ChatApisPreview/ChatApisPreview'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import { useDeleteIntegration } from 'api/chat-api-integration'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { useQueryClient } from 'react-query'
import { useContext, useState } from 'react'
import Loader from 'elements/Loader/Loader'
import { AuthContext } from 'context/Auth'

dayjs.extend(utc)
// dayjs.extend(timezone)

type Props = {
    item: any
}

const IntegrationListItem = ({ item }: Props) => {
    const queryClient = useQueryClient()

    const { user } = useContext(AuthContext)

    if (!user?.access) {
        throw new Error('User has no access and cannot fetch messages.')
    }

    const workspaceId = user?.access?.workspaceId
    const userId = user?.access?.internalUserId

    const sourceType = chatApiList?.find((chatApi) =>
        item.source.includes(chatApi.key)
    )

    const { mutate: deleteIntegration, isLoading } = useDeleteIntegration()
    const [isHover, setIsHover] = useState(false)

    return (
        <>
            <Card
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
                onMouseEnter={() => setIsHover(true)}
                onMouseLeave={() => setIsHover(false)}
            >
                {isLoading ? (
                    <Loader />
                ) : (
                    <>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                gap: '10px',
                            }}
                        >
                            {sourceType && (
                                <Typography
                                    sx={{
                                        width: '40px',
                                        height: '40px',
                                    }}
                                >
                                    <img
                                        src={sourceType.icon}
                                        alt={item.label}
                                    />
                                </Typography>
                            )}
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}
                            >
                                <Typography level="h4" sx={{}}>
                                    {sourceType?.label}
                                </Typography>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        gap: '10px',
                                    }}
                                >
                                    <Typography level="body-sm">
                                        ID: {item.id}
                                    </Typography>
                                    <Divider
                                        orientation="vertical"
                                        sx={{
                                            color: 'white',
                                        }}
                                    />
                                    <Typography level="body-sm">
                                        Date:{' '}
                                        {dayjs
                                            .utc(item.date)
                                            .format('MMM D, YYYY HH:mm')}
                                    </Typography>
                                    <Divider
                                        orientation="vertical"
                                        sx={{
                                            color: 'white',
                                        }}
                                    />
                                    <Typography level="body-sm">
                                        Phone: {item.name}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                gap: '12px',
                            }}
                        >
                            {item.status === 1 ? (
                                <Typography
                                    sx={(theme) => ({
                                        border: '1px solid #E9EEF1',
                                        borderRadius: '12px',
                                        padding: '6px 12px',
                                        width: 'fit-content',
                                        display: 'flex',
                                        gap: '4px',
                                        fontSize: '14px',
                                        alignItems: 'center',
                                        lineHeight: '14px',
                                        color: '#70828D',
                                        margin: '8px 0',
                                        background: '#F0F5F9',
                                        [theme.getColorSchemeSelector('dark')]:
                                            {
                                                background: '#181A1C',
                                                border: '1px solid #32383E',
                                                color: '#CDD7E1',
                                            },
                                    })}
                                >
                                    Authorized
                                </Typography>
                            ) : null}
                            <Box
                                sx={{
                                    width: '56px',
                                    height: '44px',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                {isHover ? (
                                    <Button
                                        variant="plain"
                                        color="neutral"
                                        onClick={() =>
                                            deleteIntegration({
                                                workspaceId: workspaceId,
                                                userId: userId,
                                                integrationId: item.id,
                                            })
                                        }
                                    >
                                        <DeleteForeverIcon />
                                    </Button>
                                ) : null}
                            </Box>
                        </Box>
                    </>
                )}
            </Card>
        </>
    )
}

export default IntegrationListItem
